<div class="flex flex-inline">
    <p-button class="downloadBtn" (click)="download()" [disabled]="selectedRow != undefined && selectedRow.length == 1 ? false : true">Download</p-button>
</div>